import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
    baseURL: API_URL,
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {

            localStorage.removeItem("token");
            localStorage.removeItem("userEmail");
            localStorage.removeItem("isVerified");
            localStorage.removeItem("journeyId");

            window.location.href = "/home";
        }

        return Promise.reject(error);
    }
);

export default api;